export default __webpack_public_path__ + "static/media/iss-marker.ff859f59.png";